import { createContext, useContext, useState } from "react";

export const SearchFilterTableContext = createContext();

export const SearchFilterTableProvider = ({ children }) => {
  const [tableData, setTableData] = useState([]);

  return (
    <SearchFilterTableContext.Provider value={{ tableData, setTableData }}>
      {children}
    </SearchFilterTableContext.Provider>
  );
};

export const useSearchFilterTableContext = () => useContext(SearchFilterTableContext);
